import { CountryCode } from "redmond";

/**
 * Builds the label sent to activities destination autocomplete for a hotel
 * cross-sell.
 *
 * The label MUST stay two-part ("City, CC"). The portal posts this to Tysons
 * (`POST /api/v0/autocomplete/experiences`), which passes the string through
 * verbatim to activities-api — it does no parsing of its own. activities-api's
 * `transformCountryCodeQuery` and its comma-split country filter then both
 * require exactly two comma-separated parts, so a three-part "City, State, CC"
 * label satisfies neither and resolves to nothing for every city — including
 * ones that work today. Matches the format `HotelConfirmation` and the flight
 * cross-sell already send.
 *
 * Qualifying the city with a country is what stops an ambiguous name (Naples,
 * Syracuse, Toledo, Alexandria) from resolving to a same-named foreign
 * destination that happens to carry more inventory.
 */
export const buildActivitiesXsellSearchLocation = (
  city: string | null | undefined,
  country: CountryCode | null | undefined
): string | null => {
  if (!city) return null;
  if (!country) return city;
  return `${city}, ${country}`;
};
